import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { PLACE_ESTATE_AGENTS_META } from "./meta.ts";
import {
  buildSearchUrl,
  buildPlaceSearchBody,
  parsePlaceSearchResponse,
  PLACE_AZURE_SEARCH_ENDPOINT,
  PLACE_AZURE_HEADERS,
} from "./runtime.ts";

export * from "./meta.ts";
export * from "./runtime.ts";

// Place's eplace.com.au is a Vue.js SPA whose listings hydrate from a
// public Azure Cognitive Search endpoint. We bypass Brightdata
// entirely for discovery and call the JSON API directly — see
// docs/snapshot-first-adapter-architecture.md. The brightdata zone is
// kept in case detail-page fetches still need an unblocker later.
export const PLACE_ESTATE_AGENTS_ADAPTER = defineSoldOnlyAdapter(
  PLACE_ESTATE_AGENTS_META,
  buildSearchUrl,
  {
    directApiDiscovery: {
      endpoint: PLACE_AZURE_SEARCH_ENDPOINT,
      method: "POST",
      headers: PLACE_AZURE_HEADERS,
      buildBody: buildPlaceSearchBody,
      parseResponse: parsePlaceSearchResponse,
    },
  },
);
